export function readModuleSpecs(data, jsonParser = JSON.parse) {
    if (data.indexOf('{') === -1) {
        return data.split(',').filter((m) => m.trim().length !== 0).map((m) => ({obj: m.trim()}));
    }

    const almostJson = data
        // remove characters 1 to 31 which for some reason break JSON parsing.
        // eslint-disable-next-line no-control-regex
        .replace(/[\u0001-\u001f]/g, '')

        // protect double quotes present in texts, before introducing legitimate JSON quotes
        .replace(/\\?"/g, '\\"')

        // replace single quotes with double quotes
        .replace(/(^|[^\\])''/g, '$1""')
        .replace(/([^\\])'/g, '$1"')
        .replace(/\\'/g, "'")

        .replace(']]', ']')
        .replace('ValueExpression[', '')
        .replace(/(\r\n|\n|\r)/gm, '');

    const json = quoteKeys(almostJson);

    let specs;
    try {
        specs = jsonParser(json);
    } catch (e) {
        if (e.message.includes('JSON.parse')) {
            // let's be clear about where the problem lies when it breaks
            console.error('Broken JSON', json);
        }
        throw e;
    }

    if (!Array.isArray(specs) && typeof specs === 'object') {
        specs = Object.keys(specs).map((moduleName) => {
            return {obj: moduleName, option: specs[moduleName]};
        });
    }

    return specs;
}


function quoteKeys(almostJson) {
    const jsonBuffer = [];
    let lastIndexOfQuote = 0;
    let currentPart;
    let currentIndexOfQuote;
    let betweenQuotes = false;
    while ((currentIndexOfQuote = almostJson.indexOf('"', lastIndexOfQuote + 1)) !== -1) {
        currentPart = almostJson.substring(lastIndexOfQuote, currentIndexOfQuote);

        if (lastIndexOfQuote !== 0 && almostJson.charAt(currentIndexOfQuote - 1) === '\\') {
            jsonBuffer.push(currentPart);
            lastIndexOfQuote = currentIndexOfQuote;
            continue;
        }

        if (!betweenQuotes) {
            currentPart = quoteKeysInPart(currentPart);
        }
        jsonBuffer.push(currentPart);

        betweenQuotes = !betweenQuotes;
        lastIndexOfQuote = currentIndexOfQuote;
    }

    jsonBuffer.push(quoteKeysInPart(almostJson.substring(lastIndexOfQuote)));

    return jsonBuffer.join('');
}

function quoteKeysInPart(objectDefPart) {
    return objectDefPart.replace(/([,{])\s*(\S+?)(\s*:)/gm, '$1"$2":');
}
